// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Address_wrapper__3KtGB","text":"Address_text__nUViA","inverted":"Address_inverted__1Jl4l"};